import type {} from '@libs/enums';
import type { ItemAttributes } from '@ps-smart-cp/ppfw-client';
import { ItemName, type ItemNames, Locale, SingleValue } from '@ps-smart-cp/ppfw-client';

interface Schema {
  // 法人税設定：タイトル
  corporateTaxFieldTitle: string;

  // 法人税設定：財務帳簿のラベルId
  bookUsedAsFinanceBook: string;

  // 法人税設定：税務帳簿のラベルId
  bookUsedAsTaxBook: string;
}

interface Record {
  readonly bookUsedAsFinanceBook: number | null;
  readonly bookUsedAsTaxBook: number | null;
}

const attributes = {
  bookUsedAsFinanceBook: SingleValue.shortValue(),
  bookUsedAsTaxBook: SingleValue.shortValue(),
} satisfies ItemAttributes<Schema>;

const names = {
  corporateTaxFieldTitle: ItemName.of([Locale.ja, '法人税の設定']),
  bookUsedAsFinanceBook: ItemName.of([Locale.ja, '財務帳簿とする帳簿']),
  bookUsedAsTaxBook: ItemName.of([Locale.ja, '税務帳簿とする帳簿']),
} satisfies ItemNames<Schema>;

interface CorporateTaxSetting {
  schema: Schema;
  record: Record;
}

export const corporateTaxSetting = {
  names,
  attributes,
};

export type { CorporateTaxSetting };
